module.exports = __webpack_public_path__ + "img/bgr-confetti.f192eea7.svg";